import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../pages/certificateAssests/logo.png";
import msme from "../pages/certificateAssests/msme.png";
import dpit from "../pages/certificateAssests/dpiit.png";
import sign from "../pages/certificateAssests/sign.png";
import badge from "../pages/certificateAssests/badge.png";
import {
  LayoutDashboard,
  BookOpen,
  Award,
  Settings,
  TrendingUp,
  Book,
  ChevronRight,
  CheckCircle,
  XCircle,
  Lock,
  Unlock,
  Eye,
  X,
  Info,
  Loader,
  Download,
  User,
  Mail,
  Activity,
  Sparkles,
  Trophy,
  ClipboardList,
  ShieldCheck,
} from 'lucide-react';
import { senvraApi } from '../utils/axiosInstance';

const getBase64Image = async (imagePath) => {
  try {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error converting image to base64:', error);
    return imagePath;
  }
};

const generateCertificateHtml = (data) => {
  // Check if certificate_id contains "QUIZ" or "INT"
  const isQuizCert = data.certificate_id && data.certificate_id.includes('QUIZ');
  const certificateTypeText = isQuizCert ? "quiz test" : "training program";
  
  return `
<style>
    .certificate {
        width: 1122px;
        height: 793px;
        position: relative; overflow: hidden;
        border: 18px solid #0b2a4a;
        box-sizing: border-box;
        background: radial-gradient(circle, #ffffff 0%, #fcf9f2 100%);
        margin: auto;
        flex-shrink: 0;
        font-family: "Times New Roman", serif;
        color: #333;
    }
    .gold-frame {
        position: absolute; top: 8px; left: 8px; right: 8px; bottom: 8px;
        border: 2px solid #d4af37;
        pointer-events: none;
    }
    .logo-left { position: absolute; top: 50px; left: 55px; }
    .logo-left img { width: 210px; }
    .badge-frame {
        position: absolute;
        top: 9px;
        right: 70px;
    }
    .badge-frame img {
        width: 140px;
        filter: drop-shadow(0px 5px 10px rgba(0,0,0,0.15));
    }
    .meta-info {
        margin: 20px auto 0 auto;
        width: 100%;
        text-align: center;
        font-size: 15px;
        color: #777;
        letter-spacing: 1px;
    }
    .main-content { text-align: center; margin-top: 100px; padding: 0 100px; }
    h1 {
        font-size: 55px;
        color: #0b2a4a; margin: 0;
        letter-spacing: 10px;
        font-weight: bold;
        text-transform: uppercase;
    }
    h2 {
        font-size: 22px; letter-spacing: 6px; color: #d4af37;
        margin: 10px 0 45px 0; font-weight: normal;
    }
    .presented-text { font-size: 22px; margin-bottom: 15px; font-style: italic; color: #555; }
    .name {
        font-size: 49px; font-weight: bold; color: #0b2a4a;
        display: inline-block; padding: 0 40px;
    }
    .name-line {
        width: 50%; border-top: 1px solid #cfcfcf;
        margin: 12px auto 25px auto;
    }
    .desc {
        font-size: 19px; line-height: 1.6; width: 80%; margin: 0 auto; color: #444;
    }
    .footer-table {
        position: absolute; bottom: 55px; width: 100%;
        border-collapse: collapse; table-layout: fixed;
    }
    .footer-col { text-align: center; vertical-align: bottom; padding: 0 20px; }
    .footer-sign { height: 80px; margin-bottom: 12px; }
    .footer-center-logo { height: 95px; margin-bottom: 10px; }
    .footer-msme { width: 180px; height: auto; margin-bottom: 10px; }
    .sig-line {
        width: 220px; margin: 0 auto;
        border-top: 2px solid #0b2a4a;
        padding-top: 10px; font-size: 15px; font-weight: bold; color: #0b2a4a;
    }
    .address-bar {
        position: absolute; bottom: 0; width: 100%;
        text-align: center; font-size: 13px; color: #fff;
        background-color: #0b2a4a; padding: 10px 0; letter-spacing: 1px;
    }
</style>
<div class="certificate">
    <div class="gold-frame"></div>
    <div class="logo-left">
        <img src="${data.logo}" alt="Logo" />
    </div>
    <div class="meta-info">
        Certificate ID: <strong>${data.certificate_id}</strong> &nbsp; | &nbsp; Date: <strong>${data.issued_date}</strong>
    </div>
    <div class="badge-frame">
        <img src="${data.badge}" alt="Medal" />
    </div>
    <div class="main-content">
        <h1>CERTIFICATE</h1>
        <h2>OF PROFESSIONAL ACHIEVEMENT</h2>
        <div class="presented-text">This Certificate is Proudly Presented To</div>
        <div class="name">${data.name}</div>
        <div class="name-line"></div>
        <div class="desc">
            Has successfully completed the
            <span style="font-weight: bold; font-size: 22px; color: #0b2a4a;">${data.course_name}</span>
            ${certificateTypeText} on <span style="font-weight: bold; font-size: 22px; color: #0b2a4a;">${data.start_date}</span>
            and fulfilled all academic and practical requirements.
            The candidate has demonstrated technical proficiency, analytical skills,
            and professional competence in accordance with organizational standards.
        </div>
    </div>
    <table class="footer-table">
        <tr>
            <td class="footer-col">
                <img src="${data.sign}" class="footer-sign" />
                <div class="sig-line">Managing Director</div>
            </td>
           <td class="footer-col">
                
                <div class="sig-line">HR Department</div>
            </td>
            <td class="footer-col">
                
                <div class="sig-line">Technical Department</div>
            </td>
        </tr>
    </table>
    <div class="address-bar">
        SENVRA AI &#8226; Hyderabad &#8226; www.senvraai.com
    </div>
</div>
  `;
};

const generateFullHtmlPage = (data) => {
  const certHtml = generateCertificateHtml(data);
  return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body {
    width: 1122px;
    height: 793px;
    overflow: hidden;
    background: white;
  }
</style>
</head>
<body>
${certHtml}
</body>
</html>`;
};

const Dashboards = () => {
  const navigate = useNavigate();

  const [dashboardData, setDashboardData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [certificateData, setCertificateData] = useState(null);
  const [base64Images, setBase64Images] = useState({
    logo: null, badge: null, sign: null, dpit: null, msme: null,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState('');
  const [isCertificateLoading, setIsCertificateLoading] = useState(false);
  const [claimingCertId, setClaimingCertId] = useState(null);
  const [certificateError, setCertificateError] = useState('');
  const iframeRef = React.useRef(null);

  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      if (footer) {
        const rect = footer.getBoundingClientRect();
        setIsFooterVisible(rect.top < window.innerHeight);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const loadImages = async () => {
      try {
        const [logoB64, badgeB64, signB64, dpitB64, msmeB64] = await Promise.all([
          getBase64Image(logo), getBase64Image(badge), getBase64Image(sign), getBase64Image(dpit), getBase64Image(msme),
        ]);
        setBase64Images({ logo: logoB64, badge: badgeB64, sign: signB64, dpit: dpitB64, msme: msmeB64 });
      } catch (error) {
        console.error('Error loading images:', error);
      }
    };
    loadImages();
  }, []);

  useEffect(() => {
    const getUserData = () => {
      try {
        let loadedUser = null;
        const userFromAuth = localStorage.getItem('user');
        const userFromCurrent = localStorage.getItem('current_user');
        const userFromData = localStorage.getItem('user_data');
        if (userFromAuth) { loadedUser = JSON.parse(userFromAuth); } 
        else if (userFromCurrent) { loadedUser = JSON.parse(userFromCurrent); } 
        else if (userFromData) {
          const user = JSON.parse(userFromData);
          if (Array.isArray(user) && user.length > 0) {
            const loginSuccess = localStorage.getItem('login_success');
            if (loginSuccess === 'true') { loadedUser = { name: user[0]?.fullName, email: user[0]?.email }; }
          } else { loadedUser = { name: user.fullName, email: user.email }; }
        }
        const token = localStorage.getItem('access_token');
        if (token && !loadedUser) {
          const payload = JSON.parse(atob(token.split('.')[1]));
          loadedUser = { name: payload.name || payload.sub, email: payload.email };
        }
        if (loadedUser) setCurrentUser(loadedUser);
      } catch (e) {
        console.error('Error getting user data:', e);
      }
    };
    getUserData();
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const fetchDashboardData = async () => {
      try {
        const response = await senvraApi.get('/dashboard', { signal: controller.signal });
        setDashboardData(response.data);
      } catch (error) {
        if (error.name !== 'CanceledError') { console.error("Error fetching dashboard data:", error); }
      } finally { setIsLoading(false); }
    };
    fetchDashboardData();
    return () => controller.abort();
  }, []);

  const handleNavigation = (path) => navigate(path);

  const handleClaimCertificate = async (certificateId, assessmentId, assessmentData) => {
    if (!certificateId) {
      setCertificateError('Certificate ID not available');
      return;
    }
    setSelectedAssessment(assessmentData);
    setClaimingCertId(assessmentId);
    setIsCertificateLoading(true);
    setCertificateError('');
    try {
      const response = await senvraApi.get(`/certificate?cert_id=${certificateId}`);
      if (response.data) {
        setCertificateData(response.data);
        const fullHtml = generateFullHtmlPage({
          name: response.data.user_name || getDisplayName(),
          course_name: response.data.course_name || assessmentData.skillDomain || 'Skill Course',
          certificate_id: response.data.cert_id || certificateId,
          issued_date: response.data.quiz_date || new Date().toLocaleDateString(),
          start_date: response.data.quiz_date || new Date().toLocaleDateString(),
          logo: base64Images.logo, badge: base64Images.badge, sign: base64Images.sign, dpit: base64Images.dpit, msme: base64Images.msme,
        });
        const blob = new Blob([fullHtml], { type: 'text/html' });
        setCertificateUrl(URL.createObjectURL(blob));
        setIsModalOpen(true);
      } else { throw new Error('Invalid certificate response'); }
    } catch (error) {
      console.error('Error fetching certificate:', error);
      setCertificateError(error.response?.data?.message || 'Failed to load certificate. Please try again.');
    } finally {
      setIsCertificateLoading(false);
      setClaimingCertId(null);
    }
  };

  const downloadAsPDF = async () => {
    if (!certificateData) {
      alert('Certificate data missing. Please try again.');
      return;
    }
    try {
      setIsCertificateLoading(true);
      const certHtmlData = {
        name: certificateData.user_name || getDisplayName(),
        course_name: certificateData.course_name || 'Skill Course',
        certificate_id: certificateData.cert_id || 'CERT-UNAVAILABLE',
        issued_date: certificateData.quiz_date || new Date().toLocaleDateString(),
        start_date: certificateData.quiz_date || new Date().toLocaleDateString(),
        logo: base64Images.logo, badge: base64Images.badge, sign: base64Images.sign, dpit: base64Images.dpit, msme: base64Images.msme,
      };

      const fullHtml = generateFullHtmlPage(certHtmlData);
      const iframe = document.createElement('iframe');
      iframe.style.cssText = `position: fixed; top: -9999px; left: -9999px; width: 1122px; height: 793px; border: none; visibility: hidden;`;
      document.body.appendChild(iframe);
      iframe.contentDocument.open();
      iframe.contentDocument.write(fullHtml);
      iframe.contentDocument.close();

      await new Promise((resolve) => {
        iframe.onload = resolve;
        setTimeout(resolve, 2000);
      });

      const html2canvas = (await import('html2canvas')).default;
      const { jsPDF } = await import('jspdf');
      const certElement = iframe.contentDocument.querySelector('.certificate');

      const canvas = await html2canvas(certElement, {
        scale: 3, useCORS: true, allowTaint: true, backgroundColor: '#ffffff',
        width: 1122, height: 793, windowWidth: 1122, windowHeight: 793,
      });

      const pdf = new jsPDF({ orientation: 'landscape', unit: 'px', format: [1122, 793] });
      pdf.addImage(canvas.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0, 1122, 793);
      pdf.save(`Senvra_Certificate_${certificateData.cert_id || 'Download'}.pdf`);
      document.body.removeChild(iframe);
    } catch (error) {
      console.error("PDF download failed:", error);
      alert('Failed to download PDF. Please try again.');
    } finally { setIsCertificateLoading(false); }
  };

  const getDisplayName = () => currentUser?.name || currentUser?.fullName || currentUser?.email?.split('@')[0] || 'User';
  const getDisplayEmail = () => currentUser?.email || '';

  const stats = dashboardData?.stats || { averagePerformance: 0, coursesAttempted: 0, certificatesUnlocked: 0 };
  const history = dashboardData?.assessmentHistory || [];

  return (
     <>
      {/* Thin scrollbar styles for sidebar nav */}
      <style>{`
        .sidebar-scroll {
          scrollbar-width: thin;
          scrollbar-color: rgba(148, 163, 184, 0.4) transparent;
        }
        .sidebar-scroll::-webkit-scrollbar {
          width: 4px;
        }
        .sidebar-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .sidebar-scroll::-webkit-scrollbar-thumb {
          background-color: rgba(148, 163, 184, 0.4);
          border-radius: 10px;
        }
      `}</style>

      <div className="flex min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 font-sans" style={{ marginTop: "112px" }}>
        <aside 
          className={`fixed left-0 top-[112px] bottom-0 w-72 bg-gradient-to-b from-[#010816] to-[#0a1a2f] text-slate-300 flex flex-col shadow-2xl z-20 transition-transform duration-300 ${isFooterVisible ? '-translate-x-full opacity-0' : 'translate-x-0 opacity-100'}`}
        >
          <div className="mb-6 px-4 pt-6">
            <div className="flex items-center gap-2">
              {/* <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-lg flex items-center justify-center">
                <Sparkles size={18} className="text-white" />
              </div>
              <h1 className="text-white text-2xl font-bold tracking-tight bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">SENVRA AI</h1> */}
            </div>
            <p className="text-xs text-slate-500 mt-2 ml-1">Certification Platform</p>
          </div>
          {/* Added `sidebar-scroll` class for thin scrollbar */}
          <nav className="flex-1 space-y-8 px-4 overflow-y-auto sidebar-scroll">
            <div className="space-y-2">
              <div className="flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-blue-600/20 to-transparent border-l-4 border-blue-500 text-blue-400 rounded-lg cursor-pointer shadow-lg">
                <LayoutDashboard size={20} />
                <span className="font-medium">Dashboard</span>
              </div>
              <div onClick={() => handleNavigation('/browse-courses')} className="flex items-center gap-3 px-4 py-3 text-slate-400 hover:text-white hover:bg-white/5 rounded-lg transition-all duration-200 cursor-pointer group">
                <BookOpen size={20} className="group-hover:scale-110 transition-transform" />
                <span>Skill Courses</span>
              </div>
            </div>
            <div>
              <p className="px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-3 flex items-center gap-2">
                <ShieldCheck size={12} /> Credentials Management
              </p>
              <div className="space-y-2">
                <div onClick={() => handleNavigation('/my-certificates')} className="flex items-center gap-3 px-4 py-3 text-slate-400 hover:text-white hover:bg-white/5 rounded-lg transition-all duration-200 cursor-pointer group">
                  <Award size={20} className="group-hover:scale-110 transition-transform" />
                  <span>My Certificates</span>
                </div>
                <div onClick={() => handleNavigation('/skill-certificate-verification')} className="flex items-center gap-3 px-4 py-3 text-slate-400 hover:text-white hover:bg-white/5 rounded-lg transition-all duration-200 cursor-pointer group">
                  <Settings size={20} className="group-hover:scale-110 transition-transform" />
                  <span>Certification Center</span>
                </div>
              </div>
            </div>
          </nav>
          <div className="mt-auto pt-4 pb-6 px-4">
            <div className="bg-gradient-to-r from-slate-800/50 to-slate-900/50 backdrop-blur-sm p-4 rounded-2xl border border-slate-700/50 shadow-xl">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center shadow-lg flex-shrink-0">
                  <User size={18} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[10px] text-slate-400 font-semibold uppercase tracking-wider">User Account</p>
                  <p className="text-white font-bold text-sm truncate" title={getDisplayName()}>{getDisplayName()}</p>
                </div>
              </div>
              {getDisplayEmail() && (
                <div className="flex items-center gap-2 mt-2 text-slate-400">
                  <Mail size={12} />
                  <p className="text-xs truncate">{getDisplayEmail()}</p>
                </div>
              )}
            </div>
          </div>
        </aside>

      <main className={`flex-1 p-6 lg:p-8 transition-all duration-300 ${isFooterVisible ? 'ml-0' : 'ml-72'}`}>
        <header className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-2">Certification Dashboard</h2>
            <p className="text-slate-500 flex items-center gap-2 text-sm">
              <Activity size={16} />
              Track your assessments, results and verified certifications.
            </p>
          </div>
          <div className="bg-gradient-to-r from-emerald-50 to-green-50 text-emerald-700 px-4 py-2 rounded-full text-xs font-bold border border-emerald-200 flex items-center gap-2 shadow-sm whitespace-nowrap">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span> 
            <span>STATUS: VERIFIED</span>
            <ShieldCheck size={14} />
          </div>
        </header>

        <div className="mb-10">
          <div className="flex justify-between items-center mb-5">
            <h3 className="text-xl lg:text-2xl font-bold text-slate-800 flex items-center gap-2">
              <TrendingUp size={22} className="text-blue-500" />
              Recent Progress
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {/* Card 1 */}
            <div className="group bg-white p-5 rounded-xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex justify-between items-start mb-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                  <TrendingUp className="text-blue-500" size={20} />
                </div>
                <span className="text-3xl font-black text-slate-200 group-hover:text-blue-100 transition-colors">01</span>
              </div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">Average Performance</p>
              <div className="flex items-baseline gap-1">
                <span className="text-3xl font-extrabold text-slate-800">{isLoading ? "..." : `${stats.averagePerformance}%`}</span>
                <span className="text-slate-400 text-sm">score</span>
              </div>
              <div className="mt-3 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-blue-400 to-blue-600 rounded-full transition-all duration-1000" style={{ width: `${stats.averagePerformance}%` }}></div>
              </div>
            </div>
            {/* Card 2 - Now lifts on hover */}
            <div className="group bg-white p-5 rounded-xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex justify-between items-start mb-3">
                <div className="p-2 bg-indigo-50 rounded-lg">
                  <ClipboardList className="text-indigo-500" size={20} />
                </div>
                <span className="text-3xl font-black text-slate-200 group-hover:text-indigo-100 transition-colors">02</span>
              </div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">Tests Attempted</p>
              <div className="flex items-baseline gap-1">
                <span className="text-3xl font-extrabold text-slate-800">{isLoading ? "..." : stats.coursesAttempted}</span>
                <span className="text-slate-400 text-sm">assessments</span>
              </div>
              <div className="mt-3 h-1.5 bg-slate-50 rounded-full" />
            </div>
            {/* Card 3 - Now lifts on hover */}
            <div className="group bg-white p-5 rounded-xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="flex justify-between items-start mb-3">
                <div className="p-2 bg-emerald-50 rounded-lg">
                  <Trophy className="text-emerald-500" size={20} />
                </div>
                <span className="text-3xl font-black text-slate-200 group-hover:text-emerald-100 transition-colors">03</span>
              </div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">Certificates Unlocked</p>
              <div className="flex items-baseline gap-1">
                <span className="text-3xl font-extrabold text-slate-800">{isLoading ? "..." : stats.certificatesUnlocked}</span>
                <span className="text-slate-400 text-sm">achievements</span>
              </div>
              <div className="mt-3 h-1.5 bg-slate-50 rounded-full" />
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-xl lg:text-2xl font-bold text-slate-800 flex items-center gap-2 mb-5">
            <ClipboardList size={22} className="text-indigo-500" />
            Assessment History
            <span className="text-sm font-normal text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full ml-2">{history.length} records</span>
          </h3>
          <div className="bg-white rounded-xl border border-slate-100 shadow-lg overflow-hidden mb-12">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-slate-50 to-white border-b border-slate-200">
                    <th className="text-left px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Skill / Domain</th>
                    <th className="text-center px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Score</th>
                    <th className="text-center px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
                    <th className="text-center px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Access</th>
                    <th className="text-right px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr><td colSpan="5" className="p-12 text-center"><div className="flex flex-col items-center gap-2"><Loader size={32} className="animate-spin text-blue-500" /><p className="text-slate-400">Loading assessment data...</p></div></td></tr>
                  ) : history.length === 0 ? (
                    <tr><td colSpan="5" className="p-12 text-center"><div className="flex flex-col items-center gap-2"><Book size={48} className="text-slate-300" /><p className="text-slate-400 font-medium">No assessment activity yet.</p><button onClick={() => handleNavigation('/browse-courses')} className="mt-2 text-blue-500 text-sm font-semibold">Start your first assessment →</button></div></td></tr>
                  ) : (
                    history.map((assessment, idx) => (
                      <tr key={assessment.id} className={`border-b border-slate-50 hover:bg-slate-50/50 transition-colors ${idx % 2 === 0 ? 'bg-white' : 'bg-slate-50/30'}`}>
                        <td className="px-6 py-5 font-bold text-slate-700">
                          <div className="flex items-center gap-2">
                            <div className="w-2 h-2 rounded-full bg-gradient-to-r from-blue-400 to-blue-600"></div>
                            {assessment.skillDomain}
                          </div>
                        </td>
                        <td className="px-6 py-5 text-center">
                          <div className="inline-flex items-center gap-1 font-bold">
                            <span className={`text-lg ${assessment.score >= 50 ? 'text-emerald-600' : assessment.status === 'Failed' ? 'text-red-500' : 'text-slate-600'}`}>{assessment.score}%</span>
                          </div>
                        </td>
                        <td className="px-6 py-5 text-center">
                          <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold ${
                            assessment.status === 'Passed' ? 'bg-emerald-50 text-emerald-600' : 
                            assessment.status === 'Failed' ? 'bg-red-50 text-red-500' : 'bg-slate-100 text-slate-500'
                          }`}>
                            {assessment.status === 'Passed' && <CheckCircle size={12} />}
                            {assessment.status === 'Failed' && <XCircle size={12} />}
                            <span>{assessment.status}</span>
                          </div>
                        </td>
                        <td className="px-6 py-5 text-center">
                          {assessment.access?.toLowerCase() === 'locked' ? (
                            <span className="inline-flex items-center gap-1 text-slate-400 text-sm"><Lock size={14} /> Locked</span>
                          ) : (
                            <span className="inline-flex items-center gap-1 text-emerald-500 text-sm"><Unlock size={14} /> Unlocked</span>
                          )}
                        </td>
                        <td className="px-6 py-5 text-right">
                          <button onClick={() => assessment.certificate_id && handleClaimCertificate(assessment.certificate_id, assessment.id, assessment)}
                            className="flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-all duration-200 text-sm font-medium ml-auto disabled:opacity-50 hover:scale-105"
                            disabled={!assessment.certificate_id}>
                            <Eye size={14} /> View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <footer className="mt-10 py-8 border-t border-slate-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <div className="flex items-center gap-2">
              <Sparkles size={14} className="text-blue-400" />
              <span>SENVRA AI Certification Platform</span>
            </div>
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-blue-600 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-blue-600 transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-blue-600 transition-colors">Support</a>
            </div>
            <div className="text-xs">
              &copy; {new Date().getFullYear()} SENVRA AI. All rights reserved.
            </div>
          </div>
        </footer>
      </main>

      {isModalOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4 md:p-8 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden transform transition-all flex flex-col border border-white/30 animate-in slide-in-from-bottom-10 duration-300">
            <div className="flex justify-between items-center px-6 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-slate-100 flex-shrink-0">
              <div className="flex items-center gap-3">
                <div className="bg-gradient-to-r from-emerald-500 to-green-500 p-2 rounded-xl shadow-md">
                  <Award size={20} className="text-white" />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-slate-800">Your Certificate of Achievement</h4>
                  <p className="text-xs text-slate-500">Verified credential</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                {certificateUrl && (
                  <button 
                    onClick={downloadAsPDF} 
                    disabled={isCertificateLoading}
                    className="hidden sm:flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white rounded-xl transition-all shadow-md active:scale-95 disabled:opacity-50 font-semibold text-sm"
                  >
                    {isCertificateLoading ? <Loader size={18} className="animate-spin" /> : <Download size={18} />}
                    Download PDF
                  </button>
                )}
                <button 
                  onClick={() => setIsModalOpen(false)} 
                  className="p-2 rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-6 bg-gradient-to-br from-slate-100/50 to-white flex flex-col items-center">
              {isCertificateLoading ? (
                <div className="flex flex-col items-center justify-center py-20">
                  <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center animate-pulse shadow-xl">
                    <Loader size={32} className="animate-spin text-white" />
                  </div>
                  <p className="text-slate-600 font-medium mt-6">Generating your certificate...</p>
                </div>
              ) : certificateUrl ? (
                <div className="w-full flex justify-center">
                  <div className="bg-white p-3 rounded-xl shadow-2xl border border-slate-200">
                    <div className="overflow-hidden rounded-lg relative" 
                         style={{ 
                           width: 'min(750px, 85vw)', 
                           height: 'calc(min(750px, 85vw) * 0.706)',
                           maxWidth: '100%' 
                         }}>
                      <iframe 
                        ref={iframeRef} 
                        src={certificateUrl} 
                        title="Certificate" 
                        scrolling="no" 
                        className="border-0 absolute top-0 left-0"
                        style={{ 
                          width: '1122px', 
                          height: '793px', 
                          transform: `scale(${Math.min(750, window.innerWidth * 0.85) / 1122})`, 
                          transformOrigin: 'top left' 
                        }} 
                      />
                    </div>
                  </div>
                </div>
              ) : certificateError ? (
                <div className="flex flex-col items-center justify-center py-16 text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                    <XCircle size={32} className="text-red-500" />
                  </div>
                  <p className="text-red-600 font-medium">{certificateError}</p>
                  <button onClick={() => setIsModalOpen(false)} className="mt-4 text-slate-500 underline">Close</button>
                </div>
              ) : null}
              
              {certificateUrl && (
                <button 
                  onClick={downloadAsPDF} 
                  disabled={isCertificateLoading}
                  className="mt-6 flex sm:hidden items-center gap-2 px-6 py-3 bg-gradient-to-r from-emerald-500 to-green-600 text-white rounded-xl font-bold w-full justify-center shadow-md"
                >
                  <Download size={18} /> Download PDF Certificate
                </button>
              )}
            </div>

            <div className="px-6 py-4 bg-white border-t border-slate-100 flex flex-col sm:flex-row gap-4 justify-between items-center flex-shrink-0">
              <div className="flex items-center gap-2 text-slate-500 bg-slate-50 px-3 py-1.5 rounded-full">
                <Info size={14} className="text-blue-500 flex-shrink-0" />
                <p className="text-[11px] leading-tight">This certificate is a verified record of your achievement. Download anytime.</p>
              </div>
              <button 
                onClick={() => setIsModalOpen(false)} 
                className="px-6 py-2 bg-slate-100 text-slate-700 font-semibold rounded-xl hover:bg-slate-200 transition-colors text-sm"
              >
                Close Preview
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default Dashboards;